import React from 'react'
import { Table } from 'antd'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import moment from 'moment'

export default function TaskResponseTasksModal({ visible, onClose, tasks }) {

    const columns = [
        {
            title: 'Tarea',
            dataIndex: 'task_template',
            render: t => t.name
        },
        {
            title: 'Resultado',
            dataIndex: 'result',
        },
        {
            title: 'Observación',
            dataIndex: 'comment'
        },
        {
            title: 'Registrado el',
            dataIndex: 'created_at',
            render: t => moment(t).format('YYYY-MMM-DD hh:mm A')
        },
        {
            title: 'Última Actualización',
            dataIndex: 'updated_at',
            render: t => moment(t).format('YYYY-MMM-DD hh:mm A')
        }
    ]

    const expandedRowRender = record => (
        <React.Fragment>
            <p><strong>Primer Seguimiento: </strong>{ record.first_follow_up ? ` ${record.first_follow_up} (${moment(record.first_follow_up_at).format('YYYY-MMM-DD hh:mm A')})` : 'Sin registro' }</p>
            <p><strong>Segundo Seguimiento: </strong>{ record.second_follow_up ? ` ${record.second_follow_up} (${moment(record.second_follow_up_at).format('YYYY-MMM-DD hh:mm A')})` : 'Sin registro' }</p>
            <p><strong>Tercer Seguimiento: </strong>{ record.third_follow_up ? ` ${record.third_follow_up} (${moment(record.third_follow_up_at).format('YYYY-MMM-DD hh:mm A')})` : 'Sin registro' }</p>
        </React.Fragment>
    )

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose} size="xl">
				<ModalHeader toggle={onClose}>Tareas Asociadas</ModalHeader>
				<ModalBody>
					<Table 
                        dataSource={tasks}
                        rowKey={record => record.id}
                        columns={columns}
                        size="small"
                        expandable={{
                            expandedRowRender
                        }}
                    />
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}